/* eslint-disable */
import {ReactComponent} from './ReactComponent';
export enum Appearances {
	Primary = 0,
	Secondary = 1,
	Tertiary = 2,
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.components.Section.ThemeMeta
*/
export interface ThemeMeta {
	surface?: string;
	onSurface?: string;
	primary?: string;
	onPrimary?: string;
	secondary?: string;
	onSecondary?: string;
}
/**
* @description Interface for Avensia.Commerce.Web.src.components.Section.SectionBlock
*/
export interface SectionBlock extends ReactComponent {
	theme?: ThemeMeta;
	appearance?: Appearances;
	full?: boolean;
	title?: string;
}
export const isSectionBlock = (model: unknown): model is SectionBlock => (model as SectionBlock).component === 'Bygghemma.Commerce.Web.src.components.Section.SectionBlock';

